module.exports = __webpack_public_path__ + "static/media/20.0bd3076f.gif";